export enum LanguageMenuText {
    None,
    ShortName,
    LongName,
    Both,
    Translation
}

